import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const SchedulesModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const strokenWidth30 = '30px'
  const strokenWidth20 = '20px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g>
          <path
            fill={fillColor200}
            opacity="0.25"
            d="M202.92,655s-87.24-47.26-95.79-163.09S81.07,398.82,67,357s.74-141.78,68.36-169.63S305.88,213.15,371.71,211s120.9-67.63,194-59.08,149.17,55.81,171.43,122.37S747.7,436.69,708.46,467.6s-100,47-120.9,67.94-40.2,91.89-99.38,126.17S337.64,742.1,202.92,655Z"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M453.52,344.35S478.21,284,546,301.21s80.84-23.84,128.11,13,56.06,94.52,37.57,125.67-35,21.42-42,75.79c-8.53,66.06-82,33.72-98.65-1.46-15.25-32.3-37.47-54.38-66.82-62.34C480,445.34,424.32,395.85,453.52,344.35Z"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M462.18,689.59s-64.3-11-62.2-80.9S359.16,535,384.87,480.81s80.1-75.25,114.52-64,28.52,29.56,83.11,24.6c66.34-6,50.72,72.75,20,96.6-28.22,21.91-44.94,48.39-46.34,78.77C555,641.78,518.79,706.91,462.18,689.59Z"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M280.33,349.22s-41.29-50.5,6.19-101.86S304.13,164.94,359.07,141s109.82-4.19,128.37,26.92,2.12,41,46.56,73.11c54,39-9.49,88.18-48.33,86C450,325,420,334,399,356,381.74,374.08,311.67,399.44,280.33,349.22Z"
          />
          <path
            fill={fillColor600}
            d="M541.61,605.1c-9.08-16.29-.66-32.38,14.88-37.4,13.82-4.75,41.61-2.34,47.48,11.89,6,14.47-14.46,32.57-29.4,36.62a35.23,35.23,0,0,1-26-3.38A24,24,0,0,1,541.61,605.1Z"
          />
          <path
            fill={fillColor600}
            d="M369.21,210.86c-17.94-4.88-22.29-25.27-21.28-42.48.11-1.9-.28-3.85-.17-5.65a7.85,7.85,0,0,1,5.8-7.58,34,34,0,0,1,5.84-.68c21.92-1.9,50.43,7.26,47.1,32.54-1.31,14-15.12,24.1-28.35,25A44.7,44.7,0,0,1,369.21,210.86Z"
          />
          <path
            fill={fillColor600}
            d="M244.68,583.54c-.58,3.66-3.36,6.8-6.49,8.78l-.1.06c-7.82,4.07-17.47,2.35-24.52-2.72a53.21,53.21,0,0,1-21.19-41.19c-.14-4.63,1-10.21,7.07-13.28a13.42,13.42,0,0,1,4.21-1.47C216.31,531.55,247.5,565.8,244.68,583.54Z"
          />
          <path
            fill={fillColor600}
            d="M665.82,269.18s48.84,79.15,5.85,165-67,78.47-123.65,103.46-94.47,137.24-200.13,155.2-46.54-127.34-87.67-169.2S93.9,557,97.5,488.53s40.67-88.27,17.4-144.3S75.81,220.62,97.37,201.94s62-41.74,120.75-26.89,105.69,56.3,142.31,61.66c60.49,8.85,92.87-44.74,143.78-41.66S610.64,184.17,665.82,269.18Z"
          />
        </g>
        <g id="Icon">
          <path
            fill={fillBG}
            strokeWidth={strokenWidth}
            stroke={strokeColor900}
            d="M534.67,618.9H253.33A70.33,70.33,0,0,1,183,548.57V290.68a70.33,70.33,0,0,1,70.33-70.34H534.67A70.33,70.33,0,0,1,605,290.68V548.57A70.33,70.33,0,0,1,534.67,618.9Z"
          />
          <path
            fill="none"
            strokeWidth={strokenWidth}
            stroke={strokeColor900}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M605,337.47H183"
          />
          <path
            fill="none"
            strokeWidth={strokenWidth}
            stroke={strokeColor900}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M300.22,194v52.75"
          />
          <path
            fill="none"
            strokeWidth={strokenWidth}
            stroke={strokeColor900}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M487.78,194v52.75"
          />
          <path
            strokeWidth={strokenWidth20}
            fill="none"
            stroke={strokeColor900}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M304.69,521.81,276.49,550l-16.91-16.91"
          />
          <path
            strokeWidth={strokenWidth20}
            fill="none"
            stroke={strokeColor900}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M464.69,451.81,436.49,480l-16.91-16.91"
          />
          <g>
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M516.34,404.08h0a1.13,1.13,0,1,1-1.13-1.13"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M515.21,403h0a1.14,1.14,0,0,1,1.13,1.13h0"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M437.18,404.08h0a1.13,1.13,0,1,1-1.13-1.13"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M436.05,403h0a1.14,1.14,0,0,1,1.13,1.13h0"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M358,404.08h0a1.13,1.13,0,1,1-1.13-1.13"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M356.91,403h0a1.14,1.14,0,0,1,1.13,1.13h0"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M278.9,471.92h0a1.13,1.13,0,1,1-2.26,0,1.12,1.12,0,0,1,1.13-1.13"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M277.77,470.79h0a1.13,1.13,0,0,1,1.13,1.13h0"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M358,471.92h0a1.13,1.13,0,1,1-2.26,0,1.12,1.12,0,0,1,1.13-1.13"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M356.91,470.79h0a1.13,1.13,0,0,1,1.13,1.13h0"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M516.34,471.92h0a1.13,1.13,0,0,1-2.26,0,1.12,1.12,0,0,1,1.13-1.13"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M515.21,470.79h0a1.13,1.13,0,0,1,1.13,1.13h0"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M516.34,539.75h0a1.13,1.13,0,1,1-1.13-1.13"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M515.21,538.62h0a1.14,1.14,0,0,1,1.13,1.13h0"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M437.18,539.75h0a1.13,1.13,0,1,1-1.13-1.13"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M436.05,538.62h0a1.14,1.14,0,0,1,1.13,1.13h0"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M358,539.75h0a1.13,1.13,0,1,1-1.13-1.13"
            />
            <path
              strokeWidth={strokenWidth30}
              fill="none"
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M356.91,538.62h0a1.14,1.14,0,0,1,1.13,1.13h0"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(SchedulesModuleBrand)
